import { call, throttle, select, put } from "redux-saga/effects";

import { USER_INTERACTION } from "state/actions/user";
import {
  authenticateSuccess,
  UNAUTHORIZED,
} from "state/actions/auth";
import { selectIAVToken } from '../selectors';
import { getIAVServer } from "./utils";

const serverKeepAliveUri = "/auth/alive";

export const KEEP_ALIVE_INTERVAL = 60 * 1000; // 1 minutes

export function* keepAlive(): any {
  try {
    const iavToken = yield select(selectIAVToken);
    if (iavToken) {
      const ssoServer = yield getIAVServer();
      const response: any = yield call(ssoServer.auth, serverKeepAliveUri, {}, iavToken);
      if (response?.alive === false) {
        yield put({ type: UNAUTHORIZED });
        return;
      }
      const { token, iavToken: updatedIavToken } = response;
      yield put(authenticateSuccess({ ...token, iavToken: updatedIavToken }));
    }
  } catch (exception: any) {
    if (exception?.response?.status === 403) {
      yield put({ type: UNAUTHORIZED });
    }
  }
}

function* keepAliveSaga() {
  yield throttle(KEEP_ALIVE_INTERVAL, USER_INTERACTION, keepAlive);
}

export default keepAliveSaga;
